module.exports = __webpack_public_path__ + "img/noContent.b30274be.png";